import React, { useEffect, useState } from "react";
import { useAuth } from "../../../contexts/auth";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import Loader from "../../../components/Loader/Loader";
import UserService from "../../../services/UserService";
import Button from "../../../components/Button/Button";
import Modal from "react-modal";
import Input from "../../../components/Input/Input";

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		backgroundColor: "var(--containerBackgroundColor)",
	},
};

const Form2fa = () => {
	const { user, storeToken, storeUser } = useAuth();
	const [showLoader, setShowLoader] = useState(false);
	const [qrCode, setQrCode] = useState(null);
	const [token, setToken] = useState("");
	const [password, setPassword] = useState("");
	const [modalIsOpen, setModalIsOpen] = useState(false);

	async function handle2FAClick() {
		setShowLoader(true);
		if (!user.userData.twoFactorAuthentication) {
			const response = await UserService.generate2FA();
			setQrCode(response.data);
		} else {
			setModalIsOpen(true);
		}
		setShowLoader(false);
	}

	async function inactivate() {
		setModalIsOpen(false);
		setShowLoader(true);
		if (await UserService.inactivate2FA(password)) {
			storeUser({
				userData: {
					...user.userData,
					twoFactorAuthentication: false,
				}
			})
		}
		setShowLoader(false);
	}

	function handleCancel() {
		setModalIsOpen(false);
	}

	useEffect(() => {
		return () => {
			if (qrCode) {
				URL.revokeObjectURL(qrCode);
			}
		};
	}, [qrCode]);

	async function handleCodeSubmit(event) {
		setShowLoader(true);
		const response = await UserService.activate2FA(token);
		if (response) {
			const { accessToken } = await UserService.validate2FA(token);
			storeUser({
				userData: {
					...user.userData,
					twoFactorAuthentication: true,
				}
			})
			storeToken(accessToken);
		}
		setShowLoader(false);
	}

	return (
		<>
			{showLoader ? (
				<Loader style={{ marginTop: '0px' }} />
			) : (
				qrCode ? (
					<form style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} onSubmit={handleCodeSubmit}>
						<p style={{ color: 'var(--textColor)', marginBottom: '15px', width: '300px', textAlign: 'center', lineHeight: '1.2' }}>
							Leia o qrcode abaixo no seu app autenticador, depois insira o primeiro código no campo abaixo para a ativação do 2fa.
						</p>
						<img src={`data:image/png;base64,${qrCode}`} alt="QRCODE para leitura no app autenticador" />
						<input
							style={{ width: '250px', margin: '15px' }}
							className="input-form"
							placeholder="Digite seu código"
							type="number"
							onChange={(e) => setToken(e.target.value)}
						/>
						<Button
							className={"button-blue"}
							disabled={!token}
							label={"Salvar"}
							type={"submit"}
						/>
					</form>
				) : (
					<ToggleButton
						style={{ width: 'fit-content' }}
						label={`${user.userData.twoFactorAuthentication ? "Autenticação de dois fatores habilitada" : "Autenticação de dois fatores desabilitada"}`}
						selected={user.userData.twoFactorAuthentication}
						onClick={() => handle2FAClick()}
						tooltipVisible={true}
						tooltipText={user.userData.twoFactorAuthentication && user.userData.isSuperAdmin ? 'Usuário super admin não pode inativar 2fa' : ''}
						disabled={user.userData.twoFactorAuthentication && user.userData.isSuperAdmin}
					/>
				)
			)}
			<div style={{ width: '350px', lineHeight: '1.4', color: 'var(--textColor)', marginTop: '20px' }}>
				<hr style={{ width: '100%', margin: '15px 0' }} />
				Alguns exemplos de aplicativos autenticadores que podem ser usados para autenticação de dois fatores (2FA) são:
				<ul style={{ marginTop: '10px', marginBottom: '10px' }}>
					<li>• Google Authenticator</li>
					<li>• Microsoft Authenticator</li>
					<li>• Authy</li>
					<li>• Duo Mobile</li>
					<li>• LastPass Authenticator</li>
					<li>• 1Password (Authenticator integrado)</li>
				</ul>
				Esses apps geram códigos temporários que você insere ao fazer login, aumentando a segurança da conta.
			</div>
			{modalIsOpen && (
				<Modal
					isOpen={modalIsOpen}
					onRequestClose={handleCancel}
					style={customStyles}
					contentLabel="Modal"
					ariaHideApp={false}
				>
					<div className="modal-content-container">
						<h1 className="modal-text">Tem certeza que deseja inativar?</h1>
						<React.Fragment>
							<p className="delete-button-modal-text">
								Esta é uma operação que não pode ser desfeita!
							</p>
							<p className="delete-button-modal-text">
								Para continuar, confirme suas credenciais:
							</p>
							<Input
								name="password"
								id="password"
								placeholder="Digite sua senha"
								value={password}
								type="password"
								autoComplete="off"
								onChange={({ target }) => setPassword(target.value)}
								required={true}
							/>
						</React.Fragment>
						<div className="modal-buttons-container">
							<Button onClick={inactivate} label="Sim"></Button>
							<Button
								className={"button-white"}
								onClick={handleCancel}
								label="Cancelar"
							></Button>
						</div>
					</div>
				</Modal>
			)}
		</>
	)
}

export default Form2fa;